import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { TimeAgoModule } from '@examdojo/core/date-time';
import { QuestionValidationHeaderComponent } from '@examdojo/question';
import {
  ConsensusFeedbackFormComponent,
  PreviousEvaluationsComponent,
  QuestionReviewTypeBadgeComponent,
} from '@examdojo/review';
import { ReviewModeBaseComponent } from '../review-mode-base.component';

@Component({
  selector: 'dojo-standard-review-sidebar',
  imports: [
    NgTemplateOutlet,
    ConsensusFeedbackFormComponent,
    QuestionValidationHeaderComponent,
    MatTabsModule,
    TimeAgoModule,
    MatExpansionModule,
    QuestionReviewTypeBadgeComponent,
    PreviousEvaluationsComponent,
  ],
  templateUrl: './standard-review-sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex h-full flex-col' },
  styles: [
    `
      ::ng-deep .mat-mdc-tab-labels {
        height: 45px;
      }
    `,
  ],
})
export class StandardReviewSidebarComponent extends ReviewModeBaseComponent {}
